module.exports = __webpack_public_path__ + "static/media/GrandEst.f7e08470.jpg";